import { render, staticRenderFns } from "./TheProfile.vue?vue&type=template&id=cf12c526&"
import script from "./TheProfile.vue?vue&type=script&lang=js&"
export * from "./TheProfile.vue?vue&type=script&lang=js&"
import style0 from "./TheProfile.vue?vue&type=style&index=0&id=cf12c526&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports